import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { login, register, logout, getCurrentUser, forgotPassword, verifyOtp, resetPassword, registerOtp, GetCompanyById, setNewPassword, update, changePassword } from '../api/auth'
import { saveToken, removeToken } from '../utils/storage'
import { getToken } from '../utils/storage'

export const useLogin = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      saveToken(data?.data?.data?.access_token)
      queryClient.invalidateQueries(['currentUser'])
    }
  })
}

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword
  })
}

export const useVerifyOtp = () => {
  return useMutation({
    mutationFn: verifyOtp
  })
}

export const useResetPassword = () => {
  return useMutation({
    mutationFn: resetPassword
  })
}

export const useChangePassword = () => {
  return useMutation({
    mutationFn: changePassword
  })
}

export const useSetNewPassword = () => {
  return useMutation({
    mutationFn: setNewPassword
  })
}

export const useRegister = () => {
  return useMutation({
    mutationFn: register
  })
}

export const useUpdate = () => {
  return useMutation({
    mutationFn: update
  })
}

export const useRegisterOTP = () => {
  return useMutation({
    mutationFn: registerOtp
  })
}

export const useLogout = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      removeToken()
      queryClient.removeQueries(['currentUser'])
    },
  })
}

export const useUser = () => {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    enabled: !!getToken(),
  })
}

export const useGetCompanyByIdQuery = (queryParams = '') => {
    return useQuery({
      queryFn: () => GetCompanyById(queryParams),
    });
};
